const setCatType3 = (payload) => {
  return {
    type: "catType3",
    payload,
  };
};

export default setCatType3;
